"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _tableReportAdapter = require("../../reducers/tableReportAdapter.js");
var _ClientReportToolbar = _interopRequireDefault(require("../ClientReportToolbar"));
var _TableReport = _interopRequireDefault(require("../TableReport"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // var AppDefs = window.cccisd.appDefs;
var headerMatch = {
  ClientReportToolbar: _ClientReportToolbar["default"]
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    activeChild: state.impact.tableReportAdapter.activeChild,
    loading: state.impact.tableReportAdapter.loading,
    fromDate: state.impact.tableReportAdapter.fromDate,
    toDate: state.impact.tableReportAdapter.toDate,
    noChildren: state.impact.tableReportAdapter.noChildren
  };
};
var TableReportAdapter = /*#__PURE__*/function (_Component) {
  _inherits(TableReportAdapter, _Component);
  function TableReportAdapter() {
    var _this;
    _classCallCheck(this, TableReportAdapter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TableReportAdapter, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getData(_this.props);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.resetState();
    });
    _defineProperty(_assertThisInitialized(_this), "changeActiveChild", function (event) {
      _this.props.changeActiveChild({
        pawn: event,
        acrossChildrenSettings: _this.props.acrossChildrenSettings,
        reportHandle: _this.props.reportHandle,
        devMetricsTags: _this.props.devMetricsTags,
        displaySettings: _this.props.displaySettings,
        dataPath: _this.props.dataPath
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getPicker", function () {
      var _this$props = _this.props,
        acrossChildrenSettings = _this$props.acrossChildrenSettings,
        selectedEntity = _this$props.entityProps.selectedEntity,
        activeChild = _this$props.activeChild;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em',
          maxWidth: '35%'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "control-label"
      }, acrossChildrenSettings.pickerLabel), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
        value: !(0, _isEmpty2["default"])(activeChild) ? (0, _find2["default"])((0, _get2["default"])(selectedEntity, acrossChildrenSettings.childrenPath), function (c) {
          return c.pawn.pawnId === activeChild.pawn.pawnId;
        }) : (0, _first2["default"])((0, _get2["default"])(selectedEntity, acrossChildrenSettings.childrenPath)),
        data: (0, _get2["default"])(selectedEntity, acrossChildrenSettings.childrenPath),
        textField: function textField(item) {
          return (0, _get2["default"])(item, acrossChildrenSettings.childTextFieldPath);
        },
        onChange: _this.changeActiveChild
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "processFields", function () {
      if (!(0, _isEmpty2["default"])((0, _filter2["default"])(_this.props.headerFields.fields, function (field) {
        return field.from === 'activeChild';
      }))) {
        return (0, _cccisdLaravelAppdefs.displayFieldsHelper)({
          fields: (0, _filter2["default"])(_this.props.headerFields.fields, function (field) {
            return field.from !== 'activeChild';
          })
        }, _this.props.entityProps.selectedEntity).concat((0, _cccisdLaravelAppdefs.displayFieldsHelper)({
          fields: (0, _filter2["default"])(_this.props.headerFields.fields, function (field) {
            return field.from === 'activeChild';
          })
        }, _this.props.activeChild));
      }
      return (0, _cccisdLaravelAppdefs.displayFieldsHelper)(_this.props.headerFields, _this.props.entityProps.selectedEntity);
    });
    return _this;
  }
  _createClass(TableReportAdapter, [{
    key: "render",
    value: function render() {
      var HeaderComponent = headerMatch[this.props.headerComponent];
      var content = '';
      if (this.props.loading) {
        content = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.loading,
          type: "inline"
        }));
      } else if (this.props.noChildren) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "No", ' ', 'childLabelPlural' in this.props.acrossChildrenSettings ? this.props.acrossChildrenSettings.childLabelPlural : 'children', ' ', "at this time");
      } else {
        content = /*#__PURE__*/_react["default"].createElement(_TableReport["default"], {
          child: this.props.activeChild,
          header: /*#__PURE__*/_react["default"].createElement(HeaderComponent, {
            currentClient: this.props.entityProps.selectedEntity,
            clientType: this.props.entityProps.typeLabel,
            fields: this.processFields(),
            heading: (0, _get2["default"])(this.props.entityProps.selectedEntity, this.props.entityProps.textFieldPath),
            datesOfService: {
              to: this.props.toDate,
              from: this.props.fromDate
            }
          }),
          reportProps: this.props.reportProps,
          isReport: this.props.isReport
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, this.getPicker(), content);
    }
  }]);
  return TableReportAdapter;
}(_react.Component);
TableReportAdapter.propTypes = {
  // the graphql query to run
  query: _propTypes["default"].string,
  // the processed variables
  variables: _propTypes["default"].object,
  // path to base of query ex: "roles.client"
  dataPath: _propTypes["default"].string,
  // the static report props from appdefs
  reportProps: _propTypes["default"].object,
  // the global display settings defined for the appdef
  displaySettings: _propTypes["default"].object,
  // json for the fields in the report header
  headerFields: _propTypes["default"].object,
  // the header component to do a match on
  headerComponent: _propTypes["default"].string,
  // flag to display as a pdf report or a browser view report
  isReport: _propTypes["default"].bool,
  /**
   *  entity props like,
   *      selectedEntity - the currently selected client
   *      typeLabel - what we call this type of client
   *      textFieldPath - the path to the user facing label of the client
   */
  entityProps: _propTypes["default"].object,
  // settings that affect child picker
  acrossChildrenSettings: _propTypes["default"].object,
  // mapping of dynamic metrics tags to standard dev metrics tags, like held, complete, date
  devMetricsTags: _propTypes["default"].object,
  // the handle of the report
  reportHandle: _propTypes["default"].string,
  // redux
  activeChild: _propTypes["default"].object,
  loading: _propTypes["default"].bool,
  toDate: _propTypes["default"].object,
  fromDate: _propTypes["default"].object,
  resetState: _propTypes["default"].func,
  changeActiveChild: _propTypes["default"].func,
  getData: _propTypes["default"].func,
  noChildren: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  getData: _tableReportAdapter.getData,
  changeActiveChild: _tableReportAdapter.changeActiveChild,
  resetState: _tableReportAdapter.resetState
})(TableReportAdapter);